<template>
    <div>
      <v-row justify="center">
        <span class="h3">Token <span class="white--text">distribution</span></span>
      </v-row>
      <v-row justify="center">
        <v-col class="d-flex justify-center" cols="12" md="12" lg="auto">
          <v-col cols="12" md="12" sm="12">
            <template>
              <v-data-table
                :items-per-page="100"
                :headers="tokenHeader"
                :items="tokenMetrics"
                hide-default-footer
                class="elevation-1 tbl"
              >
              <template v-slot:item.vest="{ item }">
                <td v-html="item.vest"></td>
              </template>

              <template v-slot:item.value="{ item }">
                <td :style="item.alc == '' ? 'color: #00ff0099' : 'color: #eca93e'">{{ item.value }}</td>
              </template>

              <template v-slot:item.perc="{ item }">
                <td :style="item.alc == '' ? 'color: #00ff0099' : ''">{{ item.perc }}</td>
              </template>

              <template v-slot:item.tokens="{ item }">
                <td :style="item.alc == '' ? 'color: #00ff0099' : ''">{{ item.tokens }}</td>
              </template>
              </v-data-table>
            </template>
          </v-col>
        </v-col>
      </v-row>
  </div>
</template>

<script>
export default {
  name: "TokenDistribution",
  data() {
    return {
      tokenHeader: [
        { text: 'Allocation', align: 'start', value: 'alc', sortable: false, width: '150', },
        { text: '%', align: 'start', value: 'perc', sortable: false },
        { text: 'Tokens', align: 'start', value: 'tokens', sortable: false },
        { text: 'Price', align: 'start', value: 'price', sortable: false },
        { text: 'Value', align: 'start', value: 'value', sortable: false },
        { text: 'Lock Period', align: 'start', value: 'lockTime', width: '100', sortable: false },
        { text: 'Vesting', align: 'start', value: 'vest', width: '100%', sortable: false },
      ],
      tokenMetrics: [ 
        { alc: 'Team', tokens: '18,750,000', perc: '15%', value: '', price: '', vest: 'Vests daily over <strong>26 months</strong>, starting month 7 onward. (approx. 5% per month)', lockTime: '6 months' },
        { alc: 'Operations', tokens: '10,000,000', perc: '8%', value: '', price: '', vest: 'Vests daily over <strong>19 months</strong>, starting month 4 onward. (approx. 6.25% per month)', lockTime: '6 months', },
        { alc: 'Marketing', tokens: '10,000,000', perc: '8%', value: '', price: '', vest: 'Vests daily over <strong>26 months</strong>, starting month 4 onward. (approx. 6.25% per month)', lockTime: '3 months', },
        { alc: 'Advisors', tokens: '6,250,000', perc: '5%', value: '', price: '', vest: 'Vests daily over <strong>26 months</strong>, starting month 2 onward. (approx. 10% per month)', lockTime: '3 months', },
        { alc: 'Reward Pools', tokens: '12,500,000', perc: '10%', value: '', price: '', vest: 'Vests daily over <strong>26 months</strong>, starting month 2 onward. (approx. 5% per month)', lockTime: '1 month', },
        { alc: 'Development Fund', tokens: '18,750,000', perc: '15%', value: '', price: '', vest: 'Vests daily over <strong>24 months</strong>, starting month 5 onward. (approx. 5% per month)', lockTime: '1 month', },
    
        { alc: 'Angel Round', tokens: '7,500,000', perc: '6%', value: '$300,000.00', price: '$0.0400', vest: 'Vests daily over <strong>1 month</strong>, starting month 2 onward. (approx. 10% per month)', lockTime: '4 months', },
        { alc: 'Strategic Round', tokens: '7,500,000', perc: '6%', value: '$525,000.00', price: '$0.0700', vest: 'Vests daily over <strong>7 months</strong>, starting month 2 onward. 5% @ TGE (approx. 15% per month)', lockTime: '1 month', },
        { alc: 'Private Round', tokens: '7,500,000', perc: '6%', value: '$637,500.00', price: '$0.0850', vest: 'Vests daily over <strong>4.5 months</strong>, starting after 15 days. 10% @ TGE (approx. 10% per month)', lockTime: '', },
        { alc: 'Public Round', tokens: '5,000,000', perc: '4%', value: '$550,000.00', price: '$0.1100', vest: 'Vests daily over <strong>1.25 months</strong>, 20% @ TGE (approx. 20% weekly)', lockTime: '', },
        { alc: 'Staking Rewards', tokens: '10,000,000', perc: '8%', value: '', price: '', vest: '', },
        { alc: 'Exchange Liquidity', tokens: '11,250,000', perc: '9%', value: '', price: '', vest: '15% used at TGE and 85% reserved.', },
        { alc: '', tokens: '125,000,000', perc: '100%', value: '$2,012.500.00', vest: '', lockTime: '' },
      ]
    }
  },
}
</script>

<style lang="scss">
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: inherit !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th:first-child {
  border-top-left-radius: 10px;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child {
  border-top-right-radius: 10px;
}

.theme--light.v-data-table > .v-data-table__wrapper > table tbody > tr:nth-child(even) {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)) !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  color: #fff !important;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.11), rgba(255, 255, 255, 0.11)) !important;
}
</style>

<style lang="scss" scoped>
.tbl {
  width: 100%;
  font-family: "Roboto";
  font-weight: 100;
  border-radius: 10px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.11), rgba(255, 255, 255, 0.11)) !important;
  color: #fff !important;
}
</style>